<template>
  <div id="main-content" class="container py-5">
    <div class="row">
      <div class="col-12">
        <h1 class="display-4 pb-3">Logout Successful</h1>
        <p>
          You have been logged out of the <strong>Group Manager</strong> application.
          Would you like to log of everything?</p>
        <p><a class="btn btn-primary btn-lg" :href="casLogoutUrl">Log out of everything</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: 'Logout',
  created() {
    this.$store.dispatch('userLogout');
  },
  computed: {
    casLogoutUrl() {
      return this.$store.state.config.casLogoutUrl;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue